import React, { useState } from "react";
import GridHeader from "./Grid/GridHeader";
import { Alert, Container } from "reactstrap";
import GridBody from "./Grid/GridBody";
import withRouter from "../../components/Common/withRouter";
import { BI_WS0025Context } from "./context";

function BI_WS0025(props) {
  const pageTitle = "Defender | Protocolo de Agendamento";
  document.title = pageTitle;

  const location = props.router.location;
  const parseParams = new URLSearchParams(location.search);
  const [filteredData, setFilteredData] = useState([])

  const [triggerOnFilter, setTriggerOnFilter] = useState(true);

  const [screenConfig, setScreenConfig] = useState({
    Protocolo: "",
    ID_Agendamento: null,
    ID_Tipo_Agendamento: null,
    Tipo_Tela: "",
    Exibir_QRCode: false,
    Exibir_Expansivo: false,
  });

  if (!parseParams.get("ID_Arquivo")) {
    return (
      <Alert color="danger">
        Não é possível acessar essa transação sem parâmetros.
      </Alert>
    );
  }

  return (
    <BI_WS0025Context.Provider
      value={{
        parseParams,
        triggerOnFilter,
        setTriggerOnFilter,
        screenConfig,
        setScreenConfig,
        pageTitle,
        filteredData,
        setFilteredData
      }}
    >
      <div className="page-content">
        <Container fluid className="p-4">
          <GridHeader />

          <GridBody />
        </Container>
      </div>
    </BI_WS0025Context.Provider>
  );
}

export default withRouter(BI_WS0025);